// extracted by mini-css-extract-plugin
export var notificationHost = "_kb-0";